import React, { useEffect, useState } from "react";
//import RatingBar from './RatingBar.jsx';
import Helper from "../functions/Helper.js";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import ExpertReviewPopup from "../components/ExpertReviewPopup.js";
import { HashLink as Link } from "react-router-hash-link";
import CustomPagination from "../components/CustomPagination";
import Spinner from "react-bootstrap/Spinner";

export default function Critic(props) {
  const { search } = useLocation();
  const [criticDetails, setCriticDetails] = useState(false);
  const [reviews, setReviews] = useState([]);
  //const [pageIndex,setPageIndex]=useState(1);
  const [pickedReview, setPickedReview] = useState(false);
  const [loadStatus, setLoadStatus] = useState("START");
  let critic_id = queryString.parse(search)?.id;
  let pageIndex = Number(queryString.parse(search)?.pg ?? 1);

  let paginationArray = [];
  for (let i = 1; i <= Math.ceil((criticDetails.reviews ?? 0) / 10); i++) {
    paginationArray.push(i);
  }
  useEffect(() => {
    if (critic_id) {
      fetch(__server__ + "/API/pub/critic_details/" + critic_id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCriticDetails(data);
        });
    }
  }, []);

  useEffect(() => {
    setLoadStatus("REFRESHING");
    if (critic_id) {
      fetch(
        __server__ +
          "/API/pub/all_reviews_by_critic/" +
          critic_id +
          "?offset=" +
          (pageIndex - 1) * 10,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setLoadStatus("LOADED");
          setReviews(data);
        });
    }
  }, [pageIndex]);

  return (
    <div>
      <ExpertReviewPopup
        hide={() => setPickedReview(false)}
        review={pickedReview}
      />
      <div>
        <p style={{ marginBottom: 10, marginTop: 10 }} id="breadcrumbs_react">
          <span>
            <Link to={"/shoe-reviews/"}>Basketball Shoes</Link> &nbsp;/&nbsp;
            <span className="breadcrumb_last">Critic Page</span>
          </span>
        </p>
      </div>

      {criticDetails ? (
        <>
          <div style={{ marginBottom: 20 }}>
            <h1 className="thg_h1_size" id="top">
              {criticDetails.name}
            </h1>
            <div style={{ fontSize: 16, fontWeight: 600 }}>
              <a href={criticDetails.homepage}>
                {criticDetails.homepage.indexOf("youtube") !== -1
                  ? "Visit Youtube Channel"
                  : "Visit Homepage"}
              </a>
            </div>
            <div
              style={{
                fontSize: 16,
                marginTop: 2,
                display: "flex",
                alignItems: "center",
              }}
            >
              {criticDetails.reviews} reviews with&nbsp;
              <span
                style={{
                  color: Helper.get_color(criticDetails.avg_rating, "text"),
                  fontWeight: 600,
                }}
              >
                {criticDetails.avg_rating}
              </span>
              &nbsp;average rating
            </div>
          </div>

          <h3 style={{ marginTop: 50 }} className="thg_h3_size">
            Latest Reviews:
          </h3>
          <div style={{ overflowX: "auto" }}>
            <table
              id="table"
              style={{
                opacity: loadStatus === "REFRESHING" ? 0.2 : 1,
                marginBottom: 5,
                width: "auto",
                borderSpacing: "0px 10px",
              }}
            >
              <tbody>
                {reviews.map((review) => (
                  <tr
                    key={review.review_id}
                    style={{ backgroundColor: "#fafafa" }}
                  >
                    <td
                      style={{
                        width: 60,
                        verticalAlign: "middle",
                        alignItems: "center",
                        padding: "8px 15px",
                        fontWeight: "600",
                        color: "white",
                        backgroundColor: Helper.get_color(review.rating, "bg"),
                      }}
                    >
                      {Number(review.rating).toFixed(1)}
                    </td>
                    <td
                      style={{
                        minWidth: 180,
                        alignItems: "center",
                        verticalAlign: "middle",
                        padding: "8px 15px",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setPickedReview(review);
                        }}
                      >
                        {review.shoe_name}
                      </span>
                    </td>
                    {["traction", "cushion", "materials", "support", "fit"].map(
                      (category) => {
                        let rating =
                          review[category] === "-1" ? "NA" : review[category];
                        return (
                          <td
                            key={category}
                            style={{
                              backgroundColor: "#fafafa",
                              width: 70,
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 10,
                            }}
                          >
                            <div
                              style={{
                                fontSize: 12,
                                lineHeight: "12px",
                                marginBottom: 6,
                              }}
                            >
                              {Helper.capitalize(category)}
                            </div>
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 16,
                                lineHeight: "16px",
                                color: Helper.get_color(rating, "text"),
                              }}
                            >
                              {rating}
                            </div>
                          </td>
                        );
                      }
                    )}

                    <td
                      style={{
                        backgroundColor: "#fafafa",
                        width: 70,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          lineHeight: "12px",
                          marginBottom: 6,
                        }}
                      >
                        Outdoor:
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 13,
                          lineHeight: "13px",
                          color: Helper.get_color(review.outdoor, "outdoor"),
                        }}
                      >
                        {Helper.getOutdoorDescription(review.outdoor)}
                      </div>
                    </td>

                    <td
                      style={{
                        fontSize: 14,
                        backgroundColor: "#fafafa",
                        width: 100,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 10,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 12,
                          lineHeight: "12px",
                          marginBottom: 6,
                        }}
                      >
                        Date:
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          fontSize: 13,
                          lineHeight: "13px",
                        }}
                      >
                        {Helper.getDateFromMysql(
                          review.date
                        ).toLocaleDateString()}
                      </div>
                    </td>
                    {/*
                      <td style={{verticalAlign:"middle",whiteSpace:"nowrap",textAlign:"right"}}>
                        <Button onClick={()=>{setShowReviewPopup(true);setCurrentReview(review)}} style={{fontSize:13,}} size="sm" variant="outline-dark">Show</Button>
                        <Link to={"/shoe-reviews/rating?user_review_id="+review.user_review_id +"&shoe_id=" + review.shoe_id}>
                          <Button  style={{fontSize:13,marginLeft:10}} size="sm" variant="outline-dark">Edit</Button>
                        </Link>
                      </td>*/}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            style={{ display: reviews.length === 0 && "none", marginTop: 20 }}
          >
            <CustomPagination
              getPaginationLink={(x) => ({
                pathname: "/shoe-reviews/critic/",
                search: "id=" + critic_id + "&pg=" + x,
              })}
              pages={paginationArray}
              pageIndex={pageIndex}
            />
          </div>
        </>
      ) : (
        <div>
          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </div>
  );
}
